module.exports = __webpack_public_path__ + "media/images/icon_photo01_18-15-f691a14c55a0050e4c39194c1542f6e9.png";